<template>
  <div class="shopList">
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="100px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="便利店名称">
          <el-input v-model="queryParam.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="add">
      <el-button type="primary" @click="addShop('add')">新增便利店</el-button>
      <el-button type="primary" @click="goWithdrawalList()">提现审核</el-button>
    </div>
    <div class="table_div">
      <el-table
        :data="shopList"
        border
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        :default-expand-all="false"
        style="width: 100%"
      >
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="storeName" label="店铺名"></el-table-column>
        <el-table-column prop="address" label="店铺地址"></el-table-column>
        <el-table-column prop="createBy" label="创建人"></el-table-column>
        <el-table-column prop="updateBy" label="更新人"></el-table-column>
        <el-table-column width="280px" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="addShop('edit', scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="addShop('query', scope.$index, scope.row)"
              >详情</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <shopAddEdit
        @saveSubmit="saveSubmit"
        :shopData="shopData"
        :isQuery="isQuery"
        v-if="drawer"
      ></shopAddEdit>
    </el-drawer>
    <el-dialog
      title="审核列表"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <withdrawal v-if="dialogVisible"></withdrawal>
    </el-dialog>
  </div>
</template>

<script>
import shopAddEdit from "./component/shopAddEdit";
import withdrawal from "./component/withdrawal";
import { publicMixin } from "@/mixins/publicMixin";
import {
  busiUserlist,
  busiUsersave,
  busiUserdelete,
  busiUserdetail,
} from "@/api/management";
export default {
  name: "shopList",
  components: { shopAddEdit, withdrawal },
  mixins: [publicMixin],
  data() {
    return {
      drawer: false,
      dialogVisible: false,
      title: "新增便利店",
      isQuery: false,
      shopData: [],
      queryParam: {
        name: "",
      },
      shopList: [],
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    goWithdrawalList() {
      this.dialogVisible = true;
    },
    addShop(where, index, row) {
      this.drawer = true;
      this.isQuery = false;
      if (where == "add") {
        this.title = "新增便利店";
      } else {
        this.title = "编辑便利店";
        if (where == "query") {
          this.title = "便利店详情";
          this.isQuery = true;
        }
        let item = row;
        let obj = {};
        obj.id = item.id;
        busiUserdetail(obj).then((res) => {
          if (res.code == 200) {
            this.shopData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    handleDelete(index, row) {
      this.$confirm("正在执行删除操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        busiUserdelete({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.currentPage = 1;
            this.getDataList();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    saveSubmit(params) {
      let data = JSON.parse(JSON.stringify(params));
      Reflect.deleteProperty(data, "contractTime");
      data.contractStart = data.contractStart + " " + "00:00:00";
      data.contractEnd = data.contractEnd + " " + "00:00:00";
      busiUsersave(data).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.$message.success("操作成功");
            this.drawer = false;
            this.currentPage = 1;
            this.getDataList();
          } else {
            this.$message.error("操作失败");
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    searchQuery() {
      this.currentPage = 1;
      this.getDataList();
    },
    getDataList() {
      let obj = {};
      obj.pageNo = this.currentPage;
      obj.pageSize = this.PageSize;
      obj.name = this.queryParam.name;
      busiUserlist(obj).then((res) => {
        if (res.code == 200) {
          this.totalCount = res.data.total;
          this.currentPage = res.data.current;
          this.PageSize = res.data.size;
          this.shopList = res.data.records;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.shopList {
  padding: 18px;
  .search_wrap {
    margin-top: 20px;
  }
  .statistics {
    width: 700px;
    display: flex;
    justify-content: space-between;
    div {
      width: 150px;
      border-radius: 12px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  .add {
    margin-top: 20px;
  }
  .table_div {
    margin-top: 20px;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
